import { makeStyles } from "@material-ui/core/styles";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React from "react";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";

// import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  root: {},
  stepper: { backgroundColor: "transparent" },
  bold: { fontWeight: "bold" },
}));

function MyStepper({ step, setStep }) {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.root}>
      <Box fontSize="20px" fontWeight="bold" ml={3} pt={3}>
        Create New Order
      </Box>
      <Grid container>
        <Grid item xs={step === 2 ? 10 : 12}>
          <Stepper activeStep={step} classes={{ root: classes.stepper }}>
            <Step active={step === 1} completed={step === 2}>
              <StepLabel>
                <div className={classes.bold}>Select Your Client</div>
              </StepLabel>
            </Step>
            <Step active={step === 2} completed={false}>
              <StepLabel>
                <div className={classes.bold}>Add Item</div>
              </StepLabel>
            </Step>
            <Step active={step === 3} completed={false}>
              <StepLabel>
                <div className={classes.bold}>Order Success</div>
              </StepLabel>
            </Step>
          </Stepper>
        </Grid>
        {step === 2 && (
          <Grid item xs={2}>
            <Box
              pt={2.5}
              width="100%"
              display="flex"
              justifyContent="flex-end"
              pr={3}
            >
              <Button
                color="secondary"
                variant="contained"
                size="small"
                onClick={() => setStep(1)}
                disableElevation
              >
                <ArrowLeftIcon /> back
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}

export default MyStepper;
